import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const ProfileScoreWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f6f8ff;
  padding: 1rem;
  width: 20vw;
  border-radius: 25px;
  // flex-grow: 0.25;
  /* margin-top: 3vh; */
  .step-title {
    font-weight: 800;
  }
  .step-group {
    margin: 20px 0;
  }
`
